import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../../lib/auth";
import { LogOut } from "lucide-react";
import BrandMark from "../../components/BrandMark";

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  if (user === null) return <div className="min-h-screen flex items-center justify-center label-mono">Проверка…</div>;
  if (user === false) { nav("/admin/login", { replace: true }); return null; }
  if (user.must_change_password) { nav("/admin/change-password", { replace: true }); return null; }

  return (
    <div className="min-h-screen flex flex-col">
      <header className="border-b border-black/10">
        <div className="max-w-screen-xl mx-auto px-8 py-4 flex items-center justify-between gap-6">
          <BrandMark />
          <nav className="flex gap-6 text-sm flex-1 justify-center">
            <NavLink to="/admin" end data-testid="nav-submissions" className={({ isActive }) => isActive ? "text-foreground" : "text-foreground/50"}>Сабмиты</NavLink>
            <NavLink to="/admin/research" data-testid="nav-research" className={({ isActive }) => isActive ? "text-foreground" : "text-foreground/50"}>Исследование</NavLink>
            {(user.role === "admin" || user.role === "superadmin") && (
              <NavLink to="/admin/profiles" data-testid="nav-profiles" className={({ isActive }) => isActive ? "text-foreground" : "text-foreground/50"}>Шкалы</NavLink>
            )}
            {user.role === "superadmin" && (
              <>
                <NavLink to="/admin/users" data-testid="nav-users" className={({ isActive }) => isActive ? "text-foreground" : "text-foreground/50"}>Пользователи</NavLink>
                <NavLink to="/admin/invites" data-testid="nav-invites" className={({ isActive }) => isActive ? "text-foreground" : "text-foreground/50"}>Приглашения</NavLink>
              </>
            )}
          </nav>
          <div className="flex items-center gap-3 text-sm">
            <span className="label-mono">{user.role}</span>
            <span className="text-foreground/70">{user.email}</span>
            <button onClick={logout} className="btn-ghost" data-testid="logout-btn"><LogOut size={14} /> Выйти</button>
          </div>
        </div>
      </header>
      <main className="flex-1 max-w-screen-xl mx-auto w-full px-8 py-10">
        <Outlet />
      </main>
    </div>
  );
}
